import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { mediaQuery } from '@lacedltd/laced-components'

export const ChipCarousel = styled.div({
  display: 'block',
  marginLeft: 'calc(50% - 50vw)',
  backgroundColor: tokens.color.yeezy[0],
  padding: `${tokens.spacing[5]} ${tokens.spacing[6]}`,
  whiteSpace: 'nowrap',
  overflow: 'scroll',
  WebkitOverflowScrolling: 'touch',
  msOverflowStyle: '-ms-autohiding-scrollbar',
  width: '100vw',
  textAlign: 'center',

  [mediaQuery.m.min]: {
    padding: `${tokens.spacing[5]} ${tokens.spacing[8]}`
  },

  '&::-webkit-scrollbar': {
    display: 'none',
    width: '0px'
  },

  '> *': {
    marginLeft: tokens.spacing[5]
  },

  'a:first-of-type': {
    marginLeft: 0
  }
})

export const Divider = styled.span({
  fontSize: tokens.fontSize[2],
  color: tokens.color.airJordan[600]
})
